import { render, staticRenderFns } from "./person_email_tab.vue?vue&type=template&id=c7522df8&"
import script from "./person_email_tab.vue?vue&type=script&lang=js&"
export * from "./person_email_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7522df8')) {
      api.createRecord('c7522df8', component.options)
    } else {
      api.reload('c7522df8', component.options)
    }
    module.hot.accept("./person_email_tab.vue?vue&type=template&id=c7522df8&", function () {
      api.rerender('c7522df8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/person_email_tab.vue"
export default component.exports